export default __webpack_public_path__ + "static/media/svg-2.5f11287c.svg";